import { FormattedMessage } from 'react-intl';

import { Chip } from '@sorare/core/src/atoms/ui/Chip';

type Props = {
  gameWeek: number;
};
export const GameWeekChip = ({ gameWeek }: Props) => {
  return (
    <Chip
      custom={{
        color: 'var(--c-neutral-1000)',
        background: 'var(--c-neutral-400)',
      }}
      size="smaller"
      label={
        <FormattedMessage
          id="GameWeekChip.chip"
          defaultMessage="GW {gameWeek}"
          values={{
            gameWeek,
          }}
        />
      }
    />
  );
};
